export const PERCUSSION_STYLE_MAP = {
  orchestral:   ['four-on-the-floor', 'syncopated', 'sparse'],
  ambient:      ['sparse', 'sparse', 'sparse'],
  jazz:         ['swing-ride', 'jazz-brush', 'bossa'],
  breakcore:    ['breakcore-amen', 'breakcore-chop', 'breakcore-drill'],
  electronic:   ['four-on-the-floor', 'syncopated', 'offbeat'],
  minimal:      ['sparse', 'four-on-the-floor', 'pulse'],
  folkAcoustic: ['folk-strum', 'sparse', 'syncopated'],
  cinematic:    ['sparse', 'timpani', 'pulse'],
  lofi:         ['lofi-dusty', 'lofi-swing', 'sparse'],
  world:        ['polyrhythm', 'clave', 'tabla'],
};

export function pickChordInterval(ctx, rand) {
  if (ctx.genre === 'ambient' || ctx.genre === 'cinematic') {
    return Math.max(1, ctx.beatsPerBar * 2);
  }
  if (ctx.genre === 'breakcore') {
    return Math.max(1, [1, 2, ctx.beatsPerBar][Math.floor(rand() * 3)]);
  }
  if (ctx.genre === 'jazz') {
    return Math.max(1, [2, ctx.beatsPerBar][Math.floor(rand() * 2)]);
  }
  const options = [ctx.beatsPerBar / 2, ctx.beatsPerBar, ctx.beatsPerBar * 2];
  return Math.max(1, options[Math.floor(rand() * options.length)]);
}

export function pickPercussionStyle(ctx, rand) {
  const styles = PERCUSSION_STYLE_MAP[ctx.genre] || PERCUSSION_STYLE_MAP.orchestral;
  return styles[Math.floor(rand() * styles.length)];
}
